import { createEffect } from 'effector';
import { parentNode$ } from 'model/mount.model';
import { render } from 'preact';

export const closeWindowFx = createEffect({
	handler: () => {
		setTimeout(() => {
			const parent = parentNode$.getState();

			if (parent) {
				render(null, parent);
				parent.remove();
			}

			window.close();
			self.close();
		}, 100);
	},
});
